import { Guid } from "@/Common/Models/Guid";
import { MedicalRequestType } from "@/Common/Models/MedicalRequest/Enum/MedicalRequestType";
import { Patient as MyleModelsPatientPatient } from "@/Common/Models/Patient/Patient";
import { MedicalItemsTab } from "@/Common/Models/Patient/PatientEnums";
import * as ServerOperations from "@/Common/Operations/operations.server";
import * as SubServerOperations from "@/Common/Operations/operations.server.sub";
import { BaseAction, IRequestExecutionContext, IResponseExecutionContext } from "@/Common/Stores/Actions/BaseAction";
import { PatientMedicalItemsHelper } from "@/Patient/Helpers/PatientMedicalItemsHelper";
import { MedicalItemTypeEnum } from "@/Patient/Models/MedicalSummary/Enum/MedicalItemTypeEnum";
import { FollowUpResponse } from "@/Patient/Models/MedicalSummary/Response/FollowUpResponse";
import { MedicationModel } from "@/Patient/Models/Medication/MedicationModel";
import { IPatientMedicalNoteModel } from "@/Patient/Models/UI/MedicalNote/IPatientMedicalNoteModel";
import { IMedicalItemsModel } from "@/Patient/Models/UI/MedicalSummary/IMedicalItemsModel";
import { IMyle_Patient_MedicalItem_DeleteMedicalItem } from "@/Patient/Stores/Handlers/Server/PatientMedicalItemsResponseHandler";

class PatientMedicalItemsActions extends BaseAction {
    constructor(onBeforeExecute?: IRequestExecutionContext, onBeforeHandleResponse?: IResponseExecutionContext) {
        super(onBeforeExecute, onBeforeHandleResponse);
    }

    public ReloadFavoriteDiagnoses(): void {
        this.Execute(ServerOperations.Server.Myle_GetFavoriteDiagnoses, { EmployeeId: sessionStore.getCurrentEmployee().ContactFacetId });
    }

    public deleteMedicalItem(medicalItemId: Guid, itemType: MedicalItemTypeEnum, patientContactId: Guid): void {
        if (!medicalItemId)
            return;

        let medicalitemsModel = patientStore.PatientMedicalItemsModels[patientContactId];
        let latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees = PatientMedicalItemsHelper.getLatestMedicalItemIdForEMRTemplate(medicalitemsModel.get("MedicalItemsList").toArray());

        let requestData: IMyle_Patient_MedicalItem_DeleteMedicalItem = {
            MedicalItemId: medicalItemId,
            MedicalItemType: itemType,
            EncounterId: medicalitemsModel.get("AllMedicalItemsList").filter(x => x.Id == medicalItemId).first().RelatedEncounterId,
            LatestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees: latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees
        };
        this.dispatch(ServerOperations.Server.Myle_Patient_MedicalItem_DeleteMedicalItem, requestData);
    }

    public SaveMedicalItem(itemsModel: IMedicalItemsModel, latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees: string, patientModel: MyleModelsPatientPatient, patientNoteModel: IPatientMedicalNoteModel, activePatientId: string, saveInNewEncounter: boolean = false, followupsToLink: FollowUpResponse[] = null, followupsToUnlink: FollowUpResponse[] = null): void {
        const isSavePlus = itemsModel.get("IsSavePlusActivated");
        const view = itemsModel.get("ItemView");

        switch (view) {
            case MedicalItemsTab.MedicalProblem:
                patientStore.ActionsMedicalItems.SaveMedicalItemMedicalProblem(itemsModel, latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees, patientModel, patientNoteModel, activePatientId, isSavePlus, saveInNewEncounter);
                break;

            case MedicalItemsTab.MedicalReactions:
                patientStore.ActionsMedicalItems.SaveMedicalItemMedicalReactions(itemsModel, latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees, patientModel, patientNoteModel, activePatientId, isSavePlus, saveInNewEncounter);
                break;

            case MedicalItemsTab.RiskFactors:
                patientStore.ActionsMedicalItems.SaveMedicalItemRiskFactor(itemsModel, latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees, patientModel, patientNoteModel, activePatientId, isSavePlus, saveInNewEncounter);
                break;

            case MedicalItemsTab.Alerts:
                patientStore.ActionsMedicalItems.SaveMedicalItemAlert(itemsModel, latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees, patientModel, patientNoteModel, activePatientId, isSavePlus, saveInNewEncounter);
                break;

            case MedicalItemsTab.FamilyHistory:
                patientStore.ActionsMedicalItems.SaveMedicalItemFamilyHistory(itemsModel, latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees, patientModel, patientNoteModel, activePatientId, isSavePlus, saveInNewEncounter);
                break;

            case MedicalItemsTab.Immunization:
                patientStore.ActionsMedicalItems.SaveMedicalItemImmunization(itemsModel, latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees, patientModel, patientNoteModel, activePatientId, isSavePlus, saveInNewEncounter);
                break;

            case MedicalItemsTab.VitalSigns:
                patientStore.ActionsMedicalItems.SaveMedicalItemVitalSign(itemsModel, latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees, patientModel, patientNoteModel, activePatientId, isSavePlus, saveInNewEncounter);
                break;

            case MedicalItemsTab.ScreeningTest:
                patientStore.ActionsMedicalItems.SaveMedicalItemScreeningTest(itemsModel, latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees, patientModel, patientNoteModel, activePatientId, isSavePlus, saveInNewEncounter, followupsToLink, followupsToUnlink);
                break;

            case MedicalItemsTab.Medication:
            case MedicalItemsTab.Medication_Edit:

                var baseMed = itemsModel.get("ActiveMedicationEditBaseMedicalItem");
                var newMed = itemsModel.get("ActiveMedicationEditNewMedicalItem");
                var medications = [];
                medications.push(baseMed);
                medications.push(newMed);
                var encounter = patientNoteModel.get("Encounter");
                patientStore.ActionsMedicalItems.SaveMedicalItemActiveMedication(medications, encounter.Id, isSavePlus, saveInNewEncounter);

                break;

            default:
                break;
        }
    }

    public SaveMedicalItemInNewEncounter(medicalItemsModel: IMedicalItemsModel, latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees: string, patientModel: MyleModelsPatientPatient, patientNoteModel: IPatientMedicalNoteModel, activePatientId: string): void {
        this.SaveMedicalItem(medicalItemsModel, latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees, patientModel, patientNoteModel, activePatientId, true);
    }

    public LoadVitalSigns(patientIdContactId: string): void {
        var requestArgs =
        {
            PatientContactId: patientIdContactId,
            EMRTemplateType: MedicalItemTypeEnum.VitalSigns,
            ResolveLookups: true
        };

        this.Execute(ServerOperations.Server.Myle_Patient_EMRTemplate_Get, requestArgs, SubServerOperations.Patient.AllVitals);
    }

    private SaveMedicalItemMedicalProblem(medicalItemsModel: IMedicalItemsModel, latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees: string, patientModel: MyleModelsPatientPatient, patientNoteModel: IPatientMedicalNoteModel, activePatientId: string, isSavePlus: boolean = false, saveInNewEncounter: boolean = false): void {
        const encounter = patientNoteModel.get("Encounter");
        const medicalItemsToSave = medicalItemsModel.get("ItemsToBeSaved").toArray();
        const isSavingFromAssessment = medicalItemsModel.get("IsEditingFromAssessment") != null ? medicalItemsModel.get("IsEditingFromAssessment") : false;
        const isFavorite = medicalItemsModel.get("IsFavorite");

        if (medicalItemsToSave && medicalItemsToSave.length > 0) {
            medicalItemsToSave.forEach(x => { if (x.ContextLookupId == null || x.ContextLookupId == undefined) x.ContextLookupId = encounter.ConsultationContextLookupId; });

            const requestData = {
                PatientContactId: activePatientId,
                PatientContactFacetId: patientModel.PatientResponse.ContactFacet_id,
                MedicalItems: medicalItemsToSave,
                SaveInNewEncounter: saveInNewEncounter,
                IsSavingFromAssessment: isSavingFromAssessment,
                LatestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees: latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees,
                IsFavorite: isFavorite
            };

            if (isSavePlus && !saveInNewEncounter)
                this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemProblem, requestData, SubServerOperations.MedicalItems.SaveMedicalItemsPlus);
            else if (saveInNewEncounter)
                this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemProblem, requestData, SubServerOperations.MedicalItems.SaveInNewEncounter);
            else
                this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemProblem, requestData, SubServerOperations.MedicalItems.SaveMedicalItems);
        }
    }

    private SaveMedicalItemMedicalReactions(medicalItemsModel: IMedicalItemsModel, latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees: string, patientModel: MyleModelsPatientPatient, patientNoteModel: IPatientMedicalNoteModel, activePatientId: string, isSavePlus: boolean = false, saveInNewEncounter: boolean = false): void {
        const encounter = patientNoteModel.get("Encounter");
        const medicalItemsToSave = medicalItemsModel.get("ItemsToBeSaved").toArray();

        if (medicalItemsToSave && medicalItemsToSave.length > 0) {
            medicalItemsToSave.forEach(x => { if (x.ContextLookupId == null || x.ContextLookupId == undefined) x.ContextLookupId = encounter.ConsultationContextLookupId; });

            var requestData = {
                PatientContactId: activePatientId,
                PatientContactFacetId: patientModel.PatientResponse.ContactFacet_id,
                MedicalItems: medicalItemsToSave,
                SaveInNewEncounter: saveInNewEncounter,
                LatestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees: latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees
            };

            if (isSavePlus && !saveInNewEncounter)
                this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemMedicalReaction, requestData, SubServerOperations.MedicalItems.SaveMedicalItemsPlus);
            else if (saveInNewEncounter)
                this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemMedicalReaction, requestData, SubServerOperations.MedicalItems.SaveInNewEncounter);
            else
                this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemMedicalReaction, requestData, SubServerOperations.MedicalItems.SaveMedicalItems);
        }
    }

    private SaveMedicalItemRiskFactor(medicalItemsModel: IMedicalItemsModel, latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees: string, patientModel: MyleModelsPatientPatient, patientNoteModel: IPatientMedicalNoteModel, activePatientId: string, isSavePlus: boolean = false, saveInNewEncounter: boolean = false): void {
        const encounter = patientNoteModel.get("Encounter");
        const medicalItemsToSave = medicalItemsModel.get("ItemsToBeSaved").toArray();

        if (medicalItemsToSave && medicalItemsToSave.length > 0) {
            medicalItemsToSave.forEach(x => { if (x.ContextLookupId == null || x.ContextLookupId == undefined) x.ContextLookupId = encounter.ConsultationContextLookupId; });

            var requestData = {
                PatientContactId: activePatientId,
                PatientContactFacetId: patientModel.PatientResponse.ContactFacet_id,
                MedicalItems: medicalItemsToSave,
                SaveInNewEncounter: saveInNewEncounter,
                LatestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees: latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees
            };

            if (isSavePlus && !saveInNewEncounter)
                this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemRiskFactor, requestData, SubServerOperations.MedicalItems.SaveMedicalItemsPlus);
            else if (saveInNewEncounter)
                this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemRiskFactor, requestData, SubServerOperations.MedicalItems.SaveInNewEncounter);
            else
                this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemRiskFactor, requestData, SubServerOperations.MedicalItems.SaveMedicalItems);
        }
    }

    private SaveMedicalItemAlert(medicalItemsModel: IMedicalItemsModel, latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees: string, patientModel: MyleModelsPatientPatient, patientNoteModel: IPatientMedicalNoteModel, activePatientId: string, isSavePlus: boolean = false, saveInNewEncounter: boolean = false): void {
        const encounter = patientNoteModel.get("Encounter");
        const medicalItemsToSave = medicalItemsModel.get("ItemsToBeSaved").toArray();

        if (medicalItemsToSave && medicalItemsToSave.length > 0) {
            medicalItemsToSave.forEach(x => { if (x.ContextLookupId == null || x.ContextLookupId == undefined) x.ContextLookupId = encounter.ConsultationContextLookupId; });

            const requestData = {
                PatientContactId: activePatientId,
                PatientContactFacetId: patientModel.PatientResponse.ContactFacet_id,
                MedicalItems: medicalItemsToSave,
                SaveInNewEncounter: saveInNewEncounter,
                LatestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees: latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees
            };

            if (isSavePlus && !saveInNewEncounter)
                this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemAlert, requestData, SubServerOperations.MedicalItems.SaveMedicalItemsPlus);
            else if (saveInNewEncounter)
                this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemAlert, requestData, SubServerOperations.MedicalItems.SaveInNewEncounter);
            else
                this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemAlert, requestData, SubServerOperations.MedicalItems.SaveMedicalItems);
        }
    }

    private SaveMedicalItemFamilyHistory(medicalItemsModel: IMedicalItemsModel, latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees: string, patientModel: MyleModelsPatientPatient, patientNoteModel: IPatientMedicalNoteModel, activePatientId: string, isSavePlus: boolean = false, saveInNewEncounter: boolean = false): void {
        const encounter = patientNoteModel.get("Encounter");
        const medicalItemsToSave = medicalItemsModel.get("ItemsToBeSaved").toArray();

        if (medicalItemsToSave && medicalItemsToSave.length > 0) {
            medicalItemsToSave.forEach(x => { if (x.ContextLookupId == null || x.ContextLookupId == undefined) x.ContextLookupId = encounter.ConsultationContextLookupId; });

            const requestData = {
                PatientContactId: activePatientId,
                PatientContactFacetId: patientModel.PatientResponse.ContactFacet_id,
                MedicalItems: medicalItemsToSave,
                SaveInNewEncounter: saveInNewEncounter,
                LatestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees: latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees
            };

            if (isSavePlus && !saveInNewEncounter)
                this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemFamilyHistory, requestData, SubServerOperations.MedicalItems.SaveMedicalItemsPlus);
            else if (saveInNewEncounter)
                this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemFamilyHistory, requestData, SubServerOperations.MedicalItems.SaveInNewEncounter);
            else
                this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemFamilyHistory, requestData, SubServerOperations.MedicalItems.SaveMedicalItems);
        }
    }

    private SaveMedicalItemImmunization(medicalItemsModel: IMedicalItemsModel, latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees: string, patientModel: MyleModelsPatientPatient, patientNoteModel: IPatientMedicalNoteModel, activePatientId: string, isSavePlus: boolean = false, saveInNewEncounter: boolean = false): void {
        const encounter = patientNoteModel.get("Encounter");
        const medicalItemsToSave = medicalItemsModel.get("ItemsToBeSaved").toArray();

        if (medicalItemsToSave && medicalItemsToSave.length > 0) {
            medicalItemsToSave.forEach(x => { if (x.ContextLookupId == null || x.ContextLookupId == undefined) x.ContextLookupId = encounter.ConsultationContextLookupId; });

            const requestData = {
                PatientContactId: activePatientId,
                PatientContactFacetId: patientModel.PatientResponse.ContactFacet_id,
                MedicalItems: medicalItemsToSave,
                SaveInNewEncounter: saveInNewEncounter,
                LatestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees: latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees
            };

            let subOp = SubServerOperations.MedicalItems.SaveMedicalItems;

            if (saveInNewEncounter)
                subOp = SubServerOperations.MedicalItems.SaveInNewEncounter;
            else if (isSavePlus)
                subOp = SubServerOperations.MedicalItems.SaveMedicalItemsPlus;

            this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemImmunization, requestData, subOp);
        }
    }

    private SaveMedicalItemVitalSign(medicalItemsModel: IMedicalItemsModel, latestVisibleMedicalItemId: string, patientModel: MyleModelsPatientPatient, patientNoteModel: IPatientMedicalNoteModel, activePatientId: string, isSavePlus: boolean = false, saveInNewEncounter: boolean = false): void {
        const encounter = patientNoteModel.get("Encounter");
        const medicalItemsToSave = medicalItemsModel.get("ItemsToBeSaved").toArray();

        if (medicalItemsToSave && medicalItemsToSave.length > 0) {
            medicalItemsToSave.forEach(x => { if (x.ContextLookupId == null || x.ContextLookupId == undefined) x.ContextLookupId = encounter.ConsultationContextLookupId; });
            const requestData = {
                PatientContactId: activePatientId,
                PatientContactFacetId: patientModel.PatientResponse.ContactFacet_id,
                MedicalItem: medicalItemsToSave.firstOrDefault(),
                SaveInNewEncounter: saveInNewEncounter,
                LatestVisibleMedicalItemId: latestVisibleMedicalItemId
            };

            if (isSavePlus && !saveInNewEncounter) {
                this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemVitalSign, requestData, SubServerOperations.MedicalItems.SaveMedicalItemsPlus);
            }
            else if (saveInNewEncounter) {
                this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemVitalSign, requestData, SubServerOperations.MedicalItems.SaveInNewEncounter);
            }
            else {
                this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemVitalSign, requestData, SubServerOperations.MedicalItems.SaveMedicalItems);
            }
        }
    }

    private SaveMedicalItemActiveMedication(medications: MedicationModel[], encounterId: string, isSavePlus: boolean = false, saveInNewEncounter: boolean = false): void {
        var MedicalItemMedicationAndPrescriptions = medications
            .filter(x => x != null)
            .map(y => y.Model);

        var requestData = {
            EncounterId: encounterId,
            ReloadMedicalItemsForEncounter: true,
            MedicalItemMedicationAndPrescriptions: MedicalItemMedicationAndPrescriptions
        };

        if (isSavePlus && !saveInNewEncounter)
            this.Execute(ServerOperations.Server.Myle_UpsertMedication, requestData, SubServerOperations.MedicalItems.SaveMedicalItemsPlus);
        else if (saveInNewEncounter)
            this.Execute(ServerOperations.Server.Myle_UpsertMedication, requestData, SubServerOperations.MedicalItems.SaveInNewEncounter);
        else
            this.Execute(ServerOperations.Server.Myle_UpsertMedication, requestData, SubServerOperations.MedicalItems.SaveMedicalItems);
    }

    private SaveMedicalItemScreeningTest(medicalItemsModel: IMedicalItemsModel, latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees: string, patientModel: MyleModelsPatientPatient, patientNoteModel: IPatientMedicalNoteModel, activePatientId: string, isSavePlus: boolean = false, saveInNewEncounter: boolean = false, followupsToLink: FollowUpResponse[] = null, followupsToUnlink: FollowUpResponse[] = null): void {
        var encounter = patientNoteModel.get("Encounter");
        var medicalItemsToSave = medicalItemsModel.get("ItemsToBeSaved").toArray();

        if (medicalItemsToSave && medicalItemsToSave.length > 0) {
            medicalItemsToSave.forEach(x => { if (x.ContextLookupId == null || x.ContextLookupId == undefined) x.ContextLookupId = encounter.ConsultationContextLookupId; });

            var requestData = {
                PatientContactId: activePatientId,
                PatientContactFacetId: patientModel.PatientResponse.ContactFacet_id,
                MedicalItem: medicalItemsToSave.firstOrDefault(),
                SaveInNewEncounter: saveInNewEncounter,
                LatestVisibleMedicalItemId: latestMedicalItemIdInTheEMRTemplateTheUserCurrentlySees,
                FollowupsToLink: followupsToLink,
                FollowupsToUnlink: followupsToUnlink
            };

            if (isSavePlus && !saveInNewEncounter) {
                this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemScreeningTest, requestData, SubServerOperations.MedicalItems.SaveMedicalItemsPlus);
            }

            else if (saveInNewEncounter)
                this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemScreeningTest, requestData, SubServerOperations.MedicalItems.SaveInNewEncounter);
            else
                this.Execute(ServerOperations.Server.Myle_Patient_MedicalItem_SaveMedicalItemScreeningTest, requestData, SubServerOperations.MedicalItems.SaveMedicalItems);
        }
    }

    public UpdateFollowupStatus(medicalRequestId: string, medicalRequestType: MedicalRequestType, statusLookupId: string): void {
        this.Execute(
            ServerOperations.Server.Myle_MedicalRequest_UpdateStatus,
            {
                MedicalRequestId: medicalRequestId,
                MedicalRequestType: medicalRequestType,
                StatusLookupId: statusLookupId
            }
        );
    }

    public saveMedicalRequestComment(requestId: string, comment: string, medicalrequesttype: MedicalRequestType): void {
        this.Execute(ServerOperations.Server.Myle_SaveMedicalRequestComment, {
            RequestId: requestId,
            Comment: comment,
            MedicalRequestType: medicalrequesttype
        });
    }
}

export { PatientMedicalItemsActions };
